import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from 'app/advice-form/form.service';
import { AdvicePdfService } from 'app/advice-form/advice-pdf.service';
import { SubmissionsService } from 'app/services/submissions.service';

const TRL_LABELS: { [statement: string]: string } = {
  A: 'TRL 1-3 (Basic Research)',
  B: 'TRL 4-5 (Applied Research)',
  C: 'TRL 6-7 (Demonstration & Implementation)',
};

@Component({
  selector: 'app-submission-view',
  templateUrl: './submission-view.component.html'
})
export class SubmissionViewComponent implements OnInit {
  readonly defaultAction: number[] = [2, 7, 11, 17, 23];
  expandedAction: { [key: number]: boolean } = {};

  loading = true;
  notFound = false;
  submission: any = null;
  sActions: number[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private submissionsService: SubmissionsService,
    private advicePdfService: AdvicePdfService,
    public formService: FormService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      this.loading = false;
      this.notFound = true;
      return;
    }
    this.submissionsService.getById(id).subscribe({
      next: (submission) => {
        this.submission = submission;
        this.formService.statement = submission.statement || '';
        this.formService.matrixAnswer = submission.answers || [];
        this.sActions = this.formService
          .getSActionsIdByMatrixKeys(submission.answers)
          .filter(action => !this.defaultAction.includes(action));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.notFound = true;
      }
    });
  }

  getTrlLabel(): string {
    const statement = this.submission?.statement;
    return statement ? TRL_LABELS[statement] || statement : '';
  }

  getQuestionKeys(): string[] {
    return this.formService.getQuestionKeysByStatement();
  }

  getActionById(id: number): string[] {
    return this.formService.getActionById(id);
  }

  expand(action: number): void {
    this.expandedAction[action] = !this.expandedAction[action];
  }

  back(): void {
    this.router.navigate(['/my-applications']);
  }

  export(): void {
    this.advicePdfService.export(
      {
        grants_agreement_number: this.submission?.grants_agreement_number,
        project_acronym: this.submission?.project_acronym,
        full_project_name: this.submission?.full_project_name,
        project_website: this.submission?.project_website,
      },
      this.formService,
      this.sActions,
      this.defaultAction
    );
  }
}
